import { useEffect } from "react";
import MapWrapper from "./components/map/MapWrapper";
import Panel from "./components/panel/Panel";
import { fetchConfig, setLanguage } from "./app/configSlice";
import { performInitialLockedSearch } from "./components/panel/searchPanel/searchSlice";
import { useAppDispatch } from "./app/hooks";
import { getDatasetId, getLanguageFromUrl } from "./utils/window-utils";
import Popup from "./components/popup/Popup";
import Logo from "./components/common/Logo/Logo";
import MapKey from "./components/map/mapKey/MapKey";
import DatasetPicker from "./components/datasetPicker/DatasetPicker";

const App = () => {
  const dispatch = useAppDispatch();
  const datasetId = getDatasetId();

  /** Startup tasks */
  useEffect(() => {
    if (datasetId) {
      dispatch(fetchConfig()).then(() => {
        const urlParamLang = getLanguageFromUrl();
        if (urlParamLang) dispatch(setLanguage(urlParamLang));
        dispatch(performInitialLockedSearch());
      });
    }

    fetch(`${import.meta.env.VITE_API_URL}/version`)
      .then((response) => response.json())
      .then((versionInfo) => {
        console.log("API version info", versionInfo);
      })
      .catch((error) => {
        console.error(
          "Error fetching API version info",
          error.message,
          import.meta.env.VITE_API_URL,
        );
      });
  }, [datasetId]);

  if (!datasetId) return <DatasetPicker />;

  return (
    <div>
      <MapWrapper />
      <Logo />
      <Panel />
      <Popup />
      <MapKey />
    </div>
  );
};

export default App;
